export type PaymentCallbackFlow = "one_time" | "schedule";

export const resolvePaymentCallbackFlow = (
  searchParams: Pick<URLSearchParams, "get">
): PaymentCallbackFlow => {
  const pay = searchParams.get("pay");

  if (pay === "one_time" || pay === "schedule") {
    return pay;
  }

  return searchParams.get("isRecurring") === "true" ? "schedule" : "one_time";
};

export const buildPayPalOneTimeReturnUrl = (
  currentUrl: string,
  status: "success" | "cancel",
  amount: string,
  offerLinkage: { offer_type?: string; vdc_id?: number } = {}
): string => {
  const returnUrl = new URL(currentUrl);
  returnUrl.search = "";
  returnUrl.hash = "";
  returnUrl.searchParams.set("pay", "one_time");
  returnUrl.searchParams.set("method", "paypal");
  returnUrl.searchParams.set("status", status);
  returnUrl.searchParams.set("checked", "false");
  returnUrl.searchParams.set("amount", amount);
  returnUrl.searchParams.set("isRecurring", "false");
  if (offerLinkage.offer_type && offerLinkage.vdc_id) {
    returnUrl.searchParams.set("offer_type", offerLinkage.offer_type);
    returnUrl.searchParams.set("vdc_id", String(offerLinkage.vdc_id));
  }

  return returnUrl.toString();
};
